module.exports = __webpack_public_path__ + "media/8-2.8bf4f6f3.mp4";